// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Light theme — aligned with Invoice screen (Invoices.css) */

.ip-inner {
  padding-top: 0;
}

.ip-header-row {
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;
}

.ip-title {
  font-size: 25px;
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #1e293b;
}

.ip-subtitle {
  margin: 8px 0 0;
  font-size: 14px;
  color: #64748b;
  line-height: 1.45;
  max-width: 560px;
}

.ip-header-tools {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.ip-badges {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.ip-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #334155;
}

.ip-badge-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.ip-badge-dot.green {
  background: #22c55e;
}

.ip-badge-dot.red {
  background: #ef4444;
}

.ip-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.ip-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  min-width: 240px;
  max-width: 360px;
  flex: 1 1;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #fff;
}

.ip-search input {
  flex: 1 1;
  border: none;
  background: transparent;
  color: #1e293b;
  font-size: 14px;
  outline: none;
  font-family: inherit;
}

.ip-search input::placeholder {
  color: #94a3b8;
}

.ip-tab-with-icon {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.ip-card-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ip-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  padding: 16px 18px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fcfcfc;
  box-shadow: 0 0 5px rgba(173, 216, 230, 0.6);
  transition: box-shadow 0.2s;
}

.ip-card-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
}

.ip-card-center {
  flex: 1 1;
  display: flex;
  justify-content: center;
  min-width: 120px;
}

.ip-card-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ip-card:hover {
  box-shadow: 0 0 8px rgba(173, 216, 230, 0.9);
}

.ip-card.running {
  border-left: 4px solid #22c55e;
}

.ip-card.stopped {
  border-left: 4px solid #f97316;
}

.ip-card-left {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  min-width: 200px;
}

.ip-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #475569;
}

.ip-card-titles {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ip-card-name {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.95rem;
  font-weight: 700;
  color: #0f172a;
}

.ip-card-sub {
  font-size: 0.8rem;
  color: #64748b;
}

.ip-card-tags {
  margin-top: 6px;
}

.ip-tag-chip {
  font-weight: 600;
  background: #e0e7ff !important;
  color: #3730a3 !important;
  border: 1px solid #c7d2fe;
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.8rem;
}

.ip-card-metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  align-items: center;
  font-size: 0.78rem;
  color: #64748b;
  flex: 1 1;
  justify-content: center;
}

.ip-card-metrics span strong {
  color: #334155;
  font-weight: 600;
}

.ip-card-right {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.ip-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  color: #334155;
}

.ip-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.ip-status-dot.green {
  background: #22c55e;
}

.ip-status-dot.red {
  background: #ef4444;
}

.ip-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 96px;
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  font-family: inherit;
  color: #fff;
  border: none;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.08), inset 0 -2px 0 rgba(0, 0, 0, 0.08);
  transition: transform 0.12s ease, box-shadow 0.18s ease, filter 0.18s ease;
}

.ip-action-btn::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.22), rgba(255, 255, 255, 0) 50%);
  pointer-events: none;
}

.ip-action-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.18), inset 0 -2px 0 rgba(0, 0, 0, 0.1);
  filter: brightness(1.05);
}

.ip-action-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.12), inset 0 2px 4px rgba(0, 0, 0, 0.15);
  filter: brightness(0.97);
}

.ip-action-btn:focus-visible {
  outline: 2px solid rgba(99, 102, 241, 0.45);
  outline-offset: 2px;
}

.ip-action-btn.start {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
}

.ip-action-btn.stop {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
}

.ip-action-btn.trigger {
  background: linear-gradient(135deg, #6366f1 0%, #4338ca 100%);
}

.ip-action-btn.trigger:not(:disabled) {
  animation: ipTriggerPulse 2.4s ease-in-out infinite;
}

@keyframes ipTriggerPulse {
  0%, 100% {
    box-shadow: 0 2px 4px rgba(15, 23, 42, 0.08), inset 0 -2px 0 rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(99, 102, 241, 0.35);
  }
  50% {
    box-shadow: 0 2px 4px rgba(15, 23, 42, 0.08), inset 0 -2px 0 rgba(0, 0, 0, 0.08), 0 0 0 6px rgba(99, 102, 241, 0);
  }
}

.ip-action-btn:disabled {
  cursor: not-allowed;
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  color: #94a3b8;
  box-shadow: none;
  filter: none;
  animation: none;
}

.ip-action-btn:disabled::before {
  display: none;
}

.ip-exec-panel {
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid #c7d2fe;
  background: #f8fafc;
  width: 100%;
}

.ip-exec-panel.ip-exec-error {
  border-color: #fecaca;
  background: #fef2f2;
}

.ip-exec-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.8rem;
  font-weight: 700;
  color: #334155;
  margin-bottom: 8px;
}

.ip-exec-done {
  font-size: 0.72rem;
  font-weight: 700;
  color: #15803d;
}

.ip-exec-err {
  font-size: 0.72rem;
  font-weight: 700;
  color: #b91c1c;
}

.ip-linear-progress {
  border-radius: 4px;
  height: 8px;
}

.ip-exec-file {
  margin-top: 8px;
  color: #1e40af;
  font-weight: 600;
}

.ip-exec-msg {
  margin-top: 6px;
  font-size: 0.8rem;
  color: #64748b;
}

.ip-exec-files {
  margin: 8px 0 0;
  padding-left: 18px;
  color: #475569;
  font-size: 0.75rem;
}

.ip-exec-files li {
  margin-bottom: 4px;
}

.ip-error-text {
  color: #b91c1c;
}

.ip-table-wrap {
  width: 100%;
  overflow-x: auto;
  border-radius: 10px;
  border: 1px solid #f6f8f9;
  background: #fcfcfc;
  margin-top: 8px;
}

.ip-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}

.ip-table th {
  text-align: left;
  padding: 14px 16px;
  font-weight: 700;
  color: #fff;
  font-size: 13px;
  border-bottom: none;
  white-space: nowrap;
  background-color: #3949ab;
}

.ip-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #e8eaf0;
  font-size: 12px;
  vertical-align: middle;
  color: #1e293b;
}

.ip-table tr:last-child td {
  border-bottom: none;
}

.ip-table tbody tr:hover {
  background: #f0f4ff;
}

.ip-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  font-family: ui-sans-serif, system-ui, sans-serif;
  white-space: nowrap;
}

.ip-pill.success {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #86efac;
}

.ip-pill.triggered {
  background: #e0e7ff;
  color: #3730a3;
  border: 1px solid #a5b4fc;
}

.ip-pill.running {
  background: #ffedd5;
  color: #9a3412;
  border: 1px solid #fdba74;
}

.ip-pill.failed {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
}

.ip-empty {
  padding: 48px 24px;
  text-align: center;
  color: #64748b;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .ip-card-metrics {
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/InvoicingProcess/InvoicingProcess.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,MAAM;EACN,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6EAA6E;EAC7E,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,6EAA6E;EAC7E,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gFAAgF;EAChF,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,gFAAgF;EAChF,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,iFAAiF;EACjF,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE;IACE,kHAAkH;EACpH;EACA;IACE,iHAAiH;EACnH;AACF;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* Light theme — aligned with Invoice screen (Invoices.css) */\n\n.ip-inner {\n  padding-top: 0;\n}\n\n.ip-header-row {\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.ip-title {\n  font-size: 25px;\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.ip-subtitle {\n  margin: 8px 0 0;\n  font-size: 14px;\n  color: #64748b;\n  line-height: 1.45;\n  max-width: 560px;\n}\n\n.ip-header-tools {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.ip-badges {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.ip-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #334155;\n}\n\n.ip-badge-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.ip-badge-dot.green {\n  background: #22c55e;\n}\n\n.ip-badge-dot.red {\n  background: #ef4444;\n}\n\n.ip-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n\n.ip-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  min-width: 240px;\n  max-width: 360px;\n  flex: 1;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n}\n\n.ip-search input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  color: #1e293b;\n  font-size: 14px;\n  outline: none;\n  font-family: inherit;\n}\n\n.ip-search input::placeholder {\n  color: #94a3b8;\n}\n\n.ip-tab-with-icon {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ip-card-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ip-card {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0;\n  padding: 16px 18px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  background: #fcfcfc;\n  box-shadow: 0 0 5px rgba(173, 216, 230, 0.6);\n  transition: box-shadow 0.2s;\n}\n\n.ip-card-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.ip-card-center {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  min-width: 120px;\n}\n\n.ip-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.ip-card:hover {\n  box-shadow: 0 0 8px rgba(173, 216, 230, 0.9);\n}\n\n.ip-card.running {\n  border-left: 4px solid #22c55e;\n}\n\n.ip-card.stopped {\n  border-left: 4px solid #f97316;\n}\n\n.ip-card-left {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n  min-width: 200px;\n}\n\n.ip-card-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  color: #475569;\n}\n\n.ip-card-titles {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ip-card-name {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.ip-card-sub {\n  font-size: 0.8rem;\n  color: #64748b;\n}\n\n.ip-card-tags {\n  margin-top: 6px;\n}\n\n.ip-tag-chip {\n  font-weight: 600;\n  background: #e0e7ff !important;\n  color: #3730a3 !important;\n  border: 1px solid #c7d2fe;\n}\n\n.mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 0.8rem;\n}\n\n.ip-card-metrics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n  align-items: center;\n  font-size: 0.78rem;\n  color: #64748b;\n  flex: 1;\n  justify-content: center;\n}\n\n.ip-card-metrics span strong {\n  color: #334155;\n  font-weight: 600;\n}\n\n.ip-card-right {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.ip-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  white-space: nowrap;\n  color: #334155;\n}\n\n.ip-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.ip-status-dot.green {\n  background: #22c55e;\n}\n\n.ip-status-dot.red {\n  background: #ef4444;\n}\n\n.ip-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-width: 96px;\n  padding: 8px 16px;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  font-family: inherit;\n  color: #fff;\n  border: none;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.08), inset 0 -2px 0 rgba(0, 0, 0, 0.08);\n  transition: transform 0.12s ease, box-shadow 0.18s ease, filter 0.18s ease;\n}\n\n.ip-action-btn::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.22), rgba(255, 255, 255, 0) 50%);\n  pointer-events: none;\n}\n\n.ip-action-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.18), inset 0 -2px 0 rgba(0, 0, 0, 0.1);\n  filter: brightness(1.05);\n}\n\n.ip-action-btn:active:not(:disabled) {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.12), inset 0 2px 4px rgba(0, 0, 0, 0.15);\n  filter: brightness(0.97);\n}\n\n.ip-action-btn:focus-visible {\n  outline: 2px solid rgba(99, 102, 241, 0.45);\n  outline-offset: 2px;\n}\n\n.ip-action-btn.start {\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\n}\n\n.ip-action-btn.stop {\n  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);\n}\n\n.ip-action-btn.trigger {\n  background: linear-gradient(135deg, #6366f1 0%, #4338ca 100%);\n}\n\n.ip-action-btn.trigger:not(:disabled) {\n  animation: ipTriggerPulse 2.4s ease-in-out infinite;\n}\n\n@keyframes ipTriggerPulse {\n  0%, 100% {\n    box-shadow: 0 2px 4px rgba(15, 23, 42, 0.08), inset 0 -2px 0 rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(99, 102, 241, 0.35);\n  }\n  50% {\n    box-shadow: 0 2px 4px rgba(15, 23, 42, 0.08), inset 0 -2px 0 rgba(0, 0, 0, 0.08), 0 0 0 6px rgba(99, 102, 241, 0);\n  }\n}\n\n.ip-action-btn:disabled {\n  cursor: not-allowed;\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  color: #94a3b8;\n  box-shadow: none;\n  filter: none;\n  animation: none;\n}\n\n.ip-action-btn:disabled::before {\n  display: none;\n}\n\n.ip-exec-panel {\n  margin-top: 14px;\n  padding: 12px 14px;\n  border-radius: 8px;\n  border: 1px solid #c7d2fe;\n  background: #f8fafc;\n  width: 100%;\n}\n\n.ip-exec-panel.ip-exec-error {\n  border-color: #fecaca;\n  background: #fef2f2;\n}\n\n.ip-exec-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #334155;\n  margin-bottom: 8px;\n}\n\n.ip-exec-done {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #15803d;\n}\n\n.ip-exec-err {\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #b91c1c;\n}\n\n.ip-linear-progress {\n  border-radius: 4px;\n  height: 8px;\n}\n\n.ip-exec-file {\n  margin-top: 8px;\n  color: #1e40af;\n  font-weight: 600;\n}\n\n.ip-exec-msg {\n  margin-top: 6px;\n  font-size: 0.8rem;\n  color: #64748b;\n}\n\n.ip-exec-files {\n  margin: 8px 0 0;\n  padding-left: 18px;\n  color: #475569;\n  font-size: 0.75rem;\n}\n\n.ip-exec-files li {\n  margin-bottom: 4px;\n}\n\n.ip-error-text {\n  color: #b91c1c;\n}\n\n.ip-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n  border-radius: 10px;\n  border: 1px solid #f6f8f9;\n  background: #fcfcfc;\n  margin-top: 8px;\n}\n\n.ip-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8125rem;\n}\n\n.ip-table th {\n  text-align: left;\n  padding: 14px 16px;\n  font-weight: 700;\n  color: #fff;\n  font-size: 13px;\n  border-bottom: none;\n  white-space: nowrap;\n  background-color: #3949ab;\n}\n\n.ip-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e8eaf0;\n  font-size: 12px;\n  vertical-align: middle;\n  color: #1e293b;\n}\n\n.ip-table tr:last-child td {\n  border-bottom: none;\n}\n\n.ip-table tbody tr:hover {\n  background: #f0f4ff;\n}\n\n.ip-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  font-family: ui-sans-serif, system-ui, sans-serif;\n  white-space: nowrap;\n}\n\n.ip-pill.success {\n  background: #dcfce7;\n  color: #166534;\n  border: 1px solid #86efac;\n}\n\n.ip-pill.triggered {\n  background: #e0e7ff;\n  color: #3730a3;\n  border: 1px solid #a5b4fc;\n}\n\n.ip-pill.running {\n  background: #ffedd5;\n  color: #9a3412;\n  border: 1px solid #fdba74;\n}\n\n.ip-pill.failed {\n  background: #fee2e2;\n  color: #991b1b;\n  border: 1px solid #fca5a5;\n}\n\n.ip-empty {\n  padding: 48px 24px;\n  text-align: center;\n  color: #64748b;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 768px) {\n  .ip-card-metrics {\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
